import React, { Component } from 'react'
// import { Link } from "react-router-dom";

export default class EventRow extends Component {
  constructor(props) {
    super(props)
  }

  changeEvent() {
    this.props.changeEvent(this.props.event)
  }

  currentEventCheck(props) {
    if(props.event.id == props.currentEvent) {
      return (
        <i className='fa fa-check' aria-hidden='true'></i>
      )
    }
  }

  render() {
    return (
      <div className="event-row-container" onClick={this.changeEvent.bind(this)}>
        <div>{this.props.event.name}</div>
        <div>{this.currentEventCheck(this.props)}</div>
      </div>
    )
  }
}
